import axios from 'axios';
import { API } from '../contexts/AuthContext';
import { essentialOils, carrierOils, herbs, recipes } from '../data/mock';

// Kick off background generation of all photos so first visits become instant.
// Guarded per-session so we only fire the request once.
export async function warmupLibrary() {
  if (sessionStorage.getItem('warmup_lib')) return;
  sessionStorage.setItem('warmup_lib', '1');
  const items = [
    ...essentialOils.map((i) => ({ item_id: i.id, name: i.name, latin: i.latin, category: 'Essential Oil', kind: 'plant' })),
    ...carrierOils.map((i) => ({ item_id: i.id, name: i.name, latin: i.latin, category: 'Carrier Oil', kind: 'plant' })),
    ...herbs.map((i) => ({ item_id: i.id, name: i.name, latin: i.latin, category: 'Herb', kind: 'plant' }))
  ];
  try {
    await axios.post(`${API}/illustrations/warmup`, { items });
  } catch (e) {
    /* non-blocking */
  }
}

export async function warmupRecipes() {
  if (sessionStorage.getItem('warmup_rec')) return;
  sessionStorage.setItem('warmup_rec', '1');
  const items = recipes.map((r) => ({ item_id: r.id, name: r.name, latin: '', category: r.type, kind: 'recipe' }));
  try {
    await axios.post(`${API}/illustrations/warmup`, { items });
  } catch (e) {
    /* non-blocking */
  }
}
